"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTable = void 0;
const react_1 = require("react");
const useTable_utils_1 = require("./useTable.utils");
function useTable({ data, columnDefs = [], defaultOptions = { sortColumnId: "", sortDirection: "asc" }, }) {
    var _a;
    const [appliedFilter, setAppliedFilter] = (0, react_1.useState)();
    const [sortColumnId, setSortColumnId] = (0, react_1.useState)(defaultOptions.sortColumnId);
    const [sortDirection, setSortDirection] = (0, react_1.useState)((_a = defaultOptions.sortDirection) !== null && _a !== void 0 ? _a : "asc");
    /**
     * `columns` are the computed version of the columnDefs passed into the hook. These columns are
     * generated by mapping to return the `header` and `id` from the column definition,
     * generating a sort function based on the `sortingFn` in the definition and
     * reversal state in `isSortReversed` and finally generating some
     * metadata from a combination of the definition and
     * the hook's internal state.
     */
    const columns = (0, react_1.useMemo)(() => columnDefs.map((columnDef) => ({
        id: columnDef.id,
        header: columnDef.header,
        metadata: {
            isSortable: !!columnDef.sort,
            isSorted: sortColumnId === columnDef.id,
        },
        sort: (overrideSortDirection) => {
            if (columnDef.sort) {
                setSortColumnId(columnDef.id);
                setSortDirection(overrideSortDirection !== null && overrideSortDirection !== void 0 ? overrideSortDirection : columnDef.sort.direction);
            }
        },
    })), [columnDefs, sortColumnId, sortDirection]);
    /**
     * `filter` function takes in a function that can be passed to
     * `Array.prototype.filter` and is applied to filter the
     * data rows passed into the hook
     */
    const filter = (0, react_1.useCallback)((filter) => {
        setAppliedFilter(() => filter);
    }, []);
    /**
     * `rows` are the transformed version of the data passed into the hook.
     * These rows are generated by applying the current filter
     * and sort/reverse sort specified by the user.
     */
    const rows = (0, react_1.useMemo)(() => {
        var _a;
        const sort = (_a = columnDefs.find((c) => c.id === sortColumnId)) === null || _a === void 0 ? void 0 : _a.sort;
        return (0, useTable_utils_1.applyTransformations)(data, {
            sort: sort ? Object.assign(Object.assign({}, sort), { direction: sortDirection }) : undefined,
            filter: appliedFilter,
        });
    }, [data, sortDirection, columnDefs, sortColumnId, appliedFilter]);
    return {
        rows,
        columns,
        metadata: {
            sortColumnId,
            sortDirection,
        },
        actions: {
            filter,
        },
    };
}
exports.useTable = useTable;
//# sourceMappingURL=useTable.js.map